import { render, staticRenderFns } from "./ViewShared.vue?vue&type=template&id=28463a30"
import script from "./ViewShared.vue?vue&type=script&lang=js"
export * from "./ViewShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports